import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { Icon, Button } from 'semantic-ui-react'
import { unescape } from '../../utils/helpers'

import ImageHeaderSlider from '../Items/ImageHeaderSlider'
import HotelDescriptions from './HotelDescriptions'

class HotelProgram extends Component {
  state = { readMore: false }

  toggleMore = () => {
    this.setState(prev => ({ readMore: !prev.readMore }))
  }

  componentDidMount = () => {
    const { hotel: { details } } = this.props
    this.props.onImage(!!details && !!details.images && details.images.headers.length > 0)
  }

  render () {
    const { readMore } = this.state
    const { color, hotel: { id, dates, subtitle, overview, details, remark, nrRooms, constructionSite }, t } = this.props

    return (
      <div>
        {/* FETCHED IMAGES */}
        {details && details.images && <ImageHeaderSlider images={details.images.headers} aspectRatio={1.5} noTransform />}

        {/* SUBTITLE */}
        <p><span style={{ color }}>{dates}</span> <strong>{subtitle}</strong></p>
        {/* OVERVIEW INFO */}
        <p>{nrRooms && `${nrRooms}x `} {overview.room}<br />{overview.included}</p>

        {/* REMARK */}
        {remark && <p>{unescape(remark)}</p>}

        {/* CONSTRUCTION SITE */}
        {constructionSite.title && <strong>{constructionSite.title}</strong>}
        {constructionSite.text && (<p>{constructionSite.text}</p>)}

        {/* READ MORE */}
        {details && details.description &&
          <p style={{ textAlign: 'center' }}>
            <Button size='large' style={{ backgroundColor: color }} icon labelPosition='right' inverted onClick={this.toggleMore} className='dossier-button'>
              {`${readMore ? t('item-list.less') : t('item-list.more')}`}
              <Icon className={`${readMore ? 'ta-minus' : 'ta-plus'}`} />
            </Button>
          </p>
        }

        {readMore && details && details.description && <HotelDescriptions lightboxId={`hotel-${id}`} {...details} />}
      </div>
    )
  }
}

export default withTranslation()(HotelProgram)
